import { createSlice } from '@reduxjs/toolkit';
import { findSettings, getSettings } from './api';
import { initialState } from './api/interface';
import { config } from '../../utils/utils';

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSettings.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSettings.fulfilled, (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findSettings.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(getSettings.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSettings.fulfilled, (state, action) => {
      state.dealerSetupFee =
        action.payload.data?.id === config.DEALER_SETUP_FEE_ID
          ? parseFloat((action.payload.data?.value || '0').toString())
          : undefined;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getSettings.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  settingsSlice.actions;
export default settingsSlice.reducer;
